import Vue from 'vue'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import './plugins/vuetify'
import App from './App'
import router from './router'
import store from './store'

Vue.use(VeeValidate)
Vue.config.productionTip = false

const dictionary = {
  en: {
    messages: {
      required: () => 'Field is Required',
      alpha: () => 'Only alphabetic characters are allowed',
      exists: () => 'Email is not registered in our system',
      email: () => 'Must be a valid email'
    }
  }
}

VeeValidate.Validator.localize(dictionary)

// Function to fetch configuration from the mounted config.json
function loadConfig() {
  return fetch('/config.json')
    .then(response => response.json())
    .then(config => {
      // Set the base URL for axios dynamically from the config
      axios.defaults.baseURL = config.apiUrl;
      console.log('API Base URL set to:', config.apiUrl);
    })
    .catch(error => {
      console.error('Failed to load config:', error);
      throw error;
    });
}

// Load the config before mounting the Vue instance
loadConfig().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}).catch(error => {
  // Handle the error case here if config loading fails
  console.error('Application failed to start due to config loading error:', error);
});
